import React from "react";
import clsx from 'clsx';
import ButtonComponent from '../../components/ButtonMC';
import TooltipMC from '../../components/TooltipMC';

const RightModalFooter = ({
  footerVariant,
  cancelLabel,
  cancelAction,
  cancelDisabled,
  submitLabel,
  submitAction,
  submitDisabled,
  submitTooltip,
  footerClassName
}) => {
  const isFooterVertical = footerVariant === 'VERTICAL';
  const hasButtons = cancelAction || submitAction;

  const footerClasses = clsx(
    'tw-pt-4 tw-px-12 tw-bg-white tw-flex tw-justify-center',
    hasButtons && 'tw-border-t',
    isFooterVertical ? 'tw-flex-col tw-gap-2 tw-pb-2' : 'tw-gap-6 tw-pb-4',
    footerClassName
  );

  return (
    <div className={footerClasses}>
      {cancelAction && (
      <ButtonComponent
        onClick={cancelAction}
        variant={isFooterVertical ? 'SECONDARY' : 'GRAY'}
        text={cancelLabel}
        className={clsx({ 'tw-order-2': isFooterVertical }, 'tw-w-full')}
        disabled={cancelDisabled}
        outlined={footerVariant === 'HORIZONTAL'}
        size="medium"
      />
      )}
      {submitAction && (
      <TooltipMC
        text={submitTooltip}
        className={clsx({ 'tw-order-1': isFooterVertical }, 'tw-w-full')}
        positionClassName="tw-min-w-52 !tw-whitespace-normal -tw-top-20"
      >
        <ButtonComponent
          onClick={submitAction}
          text={submitLabel}
          className="tw-w-full"
          disabled={submitDisabled}
          size="medium"
        />
      </TooltipMC>
      )}
    </div>
  );
};

export default RightModalFooter;
